import { FC } from 'react'
import {
  PercentageContainer,
  PercentageItemsContainer,
  PercentageItem,
  PercentageTotal
} from 'src/components/application/defaultComponents'
import Slider from 'src/components/basic/Slider'
import StandardFormatInput from 'src/components/basic/StandardFormatInput'
import { IoAlertCircle } from 'react-icons/io5'

interface AreasWithPercentage {
  area: string;
  type?: string;
  percentage: number;
}

interface Props {
  areasWithPercentage: AreasWithPercentage[];
  handleSliderChange: (value: number, index: number) => void;
  handleInputChange: (value: number, index: number) => void;
  showAlert: boolean;
  totalPercentage: number;
}

const PercentagesForm: FC<Props> = ({
  areasWithPercentage,
  handleSliderChange,
  handleInputChange,
  showAlert,
  totalPercentage
}) => {
  return (
    <PercentageContainer>
      <PercentageItemsContainer>
        {areasWithPercentage.map((area, index) => (
          <PercentageItem key={index}>
            <h6>{area.type ? `${area.type}` : area.area}</h6>
            <span>Total Amount</span>
            <div className='slider-input-container'>
              <Slider
                value={area.percentage ?? 0}
                onChange={value => handleSliderChange(value as number, index)}
              />
              <StandardFormatInput
                label=''
                maskStyle='percentage'
                decimalScale={1}
                isAllowed={({ floatValue }) => ((floatValue ?? 0) / 10) <= 100}
                onValueChange={({ floatValue }) => handleInputChange(floatValue ?? 0, index)}
                value={area.percentage * 10 ?? 0}
              />
            </div>
          </PercentageItem>
        ))}
      </PercentageItemsContainer>
      <PercentageTotal isValid={!showAlert}>
        <div>
          <h4>Total Percentage</h4>
          <span>Total must add up to 100%</span>
          <h1 style={{marginTop: "10px"}}>{totalPercentage}%</h1>
          {showAlert ? (
            <div className='error-container'>
              <IoAlertCircle />
              {totalPercentage !== 100 ? (
                <span>Total is {totalPercentage > 100 ? 'greater' : 'less'} than 100%</span>
              ) : (
                <span>All areas of practice must have a value. If 0%, please go back to the previous screen and remove that area of practice</span>
              )}
            </div>
          ) : null}
        </div>
      </PercentageTotal>
    </PercentageContainer>
  )
}

export default PercentagesForm